import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import VConsole from "vconsole";
// const vConsole = new VConsole();
// 或者使用配置参数来初始化，详情见文档
// Vue.use(vConsole);

Vue.use(ElementUI);
Vue.use(Antd);

Vue.config.productionTip = false;

import { numberToCurrencyNo, modelchangeFilter } from '@/utils/utils';
// 配置全局过滤器，实现数字千分位格式
Vue.filter('numberToCurrency', numberToCurrencyNo);
Vue.filter('modelchangeFilter', modelchangeFilter);

// 导入字体图标
import '@/assets/font/iconfont.css';
import '@/assets/font/yugothic.css';

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
